/**
 * Compact recency label for an activity row: minutes and hours for today, a calendar date before that.
 *
 * The app has two relative-time formats, this one and formatLastActivityForCell in ./format-last-activity.
 * They will soon be brought together into a single way of showing this type of time format.
 */
export function formatMatterActivityTime(timestamp: number, now = new Date(Date.now())): string {
  if (!Number.isFinite(timestamp) || timestamp <= 0) return ''
  const date = new Date(timestamp)
  if (date.toDateString() !== now.toDateString()) {
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined,
    })
  }
  const minutes = Math.max(0, Math.floor((now.getTime() - timestamp) / 60_000))
  if (minutes < 1) return 'Just now'
  if (minutes < 60) return `${minutes}m ago`
  return `${Math.floor(minutes / 60)}h ago`
}
